import API from './apiConfig';

export const getTransportForm = async () => {
  const id = localStorage.getItem("participant_id")
    ? JSON.parse(localStorage.getItem("participant_id"))
    : "0000";
  try {
    const response = await API.get(`/transportation/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTransportSettings = async (id) => {
  try {
    const response = await API.get(`/transportation_setting/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postTransportForm = async (formData) => {
  const id = localStorage.getItem("participant_id")
    ? JSON.parse(localStorage.getItem("participant_id"))
    : "0000";
  try {
    const response = await API.post(`/transportation/${id}`,formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateTransportForm = async (formData) => {
  const id = localStorage.getItem("participant_id")
    ? JSON.parse(localStorage.getItem("participant_id"))
    : "0000";
  try {
    const response = await API.put(`/transportation/${id}`,formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};